import React from "react";
import { Link } from "react-router-dom";
import {
  faSearch,
  faHeart,
  faShoppingCart,
  faUser,
  faLanguage,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import image from "../../src/assets/liquid-logo.png"
import background from "../../src/assets/tshirtbg.png"

const products = [
  {
    id: 1,
    name: "Product 1",
    frontImage:
      background,
    backImage:
      "https://cdn.pixabay.com/photo/2016/12/06/09/30/blank-1886001_640.png",
    details: "T-Shirt UNIVERSE",
    details1: "XS S M S XL L",
    details2: "ZUM WarenKorb hinzufugen",
  },

  {
    id: 2,
    name: "Product 1",
    frontImage:
      background,
    backImage:
      "https://cdn.pixabay.com/photo/2016/12/06/09/30/blank-1886001_640.png",
    details: "T-Shirt UNIVERSE",
    details1: "XS S M S XL L",
    details2: "ZUM WarenKorb hinzufugen",
  },

  {
    id: 3,
    name: "Product 1",
    frontImage:
      background,
    backImage:
      "https://cdn.pixabay.com/photo/2016/12/06/09/30/blank-1886001_640.png",
    details: "T-Shirt UNIVERSE",
    details1: "XS S M S XL L",
    details2: "ZUM WarenKorb hinzufugen",
  },

  {
    id: 4,
    name: "Product 1",
    frontImage:
      background,
    backImage:
      "https://cdn.pixabay.com/photo/2016/12/06/09/30/blank-1886001_640.png",
    details: "T-Shirt UNIVERSE",
    details1: "XS S M S XL L",
    details2: "ZUM WarenKorb hinzufugen",
  },
  {
    id: 5,
    name: "Product 1",
    frontImage:
      background,
    backImage:
    "https://cdn.pixabay.com/photo/2016/12/06/09/30/blank-1886001_640.png",
    details: "T-Shirt UNIVERSE",
    details1: "XS S M S XL L",
    details2: "ZUM WarenKorb hinzufugen",
  },

  {
    id: 6,
    name: "Product 1",
    frontImage:
      background,
    backImage:
    "https://cdn.pixabay.com/photo/2016/12/06/09/30/blank-1886001_640.png",
    details: "T-Shirt UNIVERSE",
    details1: "XS S M S XL L",
    details2: "ZUM WarenKorb hinzufugen",
  },

  {
    id: 7,
    name: "Product 1",
    frontImage:
      background,
    backImage:
    "https://cdn.pixabay.com/photo/2016/12/06/09/30/blank-1886001_640.png",
    details: "T-Shirt UNIVERSE",
    details1: "XS S M S XL L",
    details2: "ZUM WarenKorb hinzufugen",
  },

  {
    id: 8,
    name: "Product 1",
    frontImage:
      background,
    backImage:
     "https://cdn.pixabay.com/photo/2016/12/06/09/30/blank-1886001_640.png",
    details: "T-Shirt UNIVERSE",
    details1: "XS S M S XL L",
    details2: "ZUM WarenKorb hinzufugen",
  },

  // Add more products as needed...
];

const Products = () => {
  return (
    <div className="flex flex-wrap gap-y-44 p-8 my-32 matchfont">
      {products.map((product) => (
        <Link
          to="/details"
          key={product.id}
          className="relative w-72 h-72 perspective group"
        >
          <div className="absolute inset-0 w-72 transform transition-transform duration-700 flip-card">
            {/* Front Side */}
            <div className="absolute w-72 inset-0 flex items-center justify-center backface-hidden">
              <img
                src={product.frontImage}
                alt={product.name}
                className="w-full h-full object-cover"
              />
            </div>
            {/* Back Side */}
            <div className="absolute w-72 inset-0 flex flex-col items-center justify-center transform rotate-y-180 backface-hidden">
              <img
                src={product.backImage}
                alt={product.name}
                className="w-full h-full object-contain mb-2"
              />
            </div>
            <div className="w-8 h-8 absolute right-0 backface-hidden">
              <img src={image} alt="logo"/>
            </div>
          </div>
          {/* Product Details */}
       
          <div className="opacity-0 mb-2 group-hover:opacity-100 transition-opacity duration-300 absolute -bottom-36 left-0 right-0 p-4 text-center">
           
          <p className="text-xs  text-black p-2 text-center">
            PLANT BASED DYED GARMENT
          </p >
          <div className="flex justify-center gap-3 p-2 items-center">
          <p >{product.details}</p>
            <p>   <FontAwesomeIcon icon={faHeart} /></p>
          </div>
          
            <p className="flex text-center font-normal gap-3 justify-center items-center">
              <div>XS</div>
              <div>S</div>
              <div>L</div>
              <div>XL</div>
              <div>2XL</div>
            
            </p>
            <div className="flex justify-center p-2 items-center ">
            <p className="text-center">34.90 ₹</p>
           
            </div>
          
          </div>
          <div className="opacity-0 group-hover:opacity-100 flex justify-center items-center gap-5 transition-opacity duration-300 absolute -bottom-40 left-0 right-0 bg-[#264374] text-white p-2 mt-1 text-center">
          <FontAwesomeIcon icon={faShoppingCart}/>
          <p>Add To Cart</p> 
          </div>
        </Link>
      ))}
    </div>
  );
};

export default Products;
